import React from 'react';
import ThanksLeft from 'assets/thanks-left.png';
import ThanksRight from 'assets/thanks-right.png';
import ThanksArrow from 'assets/thanks-arrow.png';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import { THANKS_TEXT } from 'utils/constant';

import './index.pc.scss';

const PresentPC = ({
  onClickMainButton,
  lpMode,
}) => {  
  const { Orei, BoxTitle, leftSubTitle, leftDetail, leftAnnotationText, leftAsteriskText,
    rightSubTitle, rightDetail, rightAnnotationText } = THANKS_TEXT;
  const DispText = (text) => {
    return Array.isArray(text) 
      ? text.map(line => {
        return(
          <div key={line} className="">
            {line}
          </div>
        );
      })
      : <>{text}</>;
  };
  return(
    <div className="PcThanks">
      <PcBasicTemplate
        path={window.location.pathname} 
        onClickMainButton={onClickMainButton}
        lpMode={lpMode}
      >
        <div className="PcOrei">
          {DispText(Orei)}
        </div>
        
        <div className="kongoBox Container">
          <span className="BoxTitle">
            {DispText(BoxTitle)}
          </span>
  
          <div className="PcLeftContent ContainerUtemLeft">
            <div className="PcLeftImagebox">
              <img className="PcLeftImage" src={ThanksLeft} alt="image1" />
            </div>
            <div className="SubTitle">
              {DispText(leftSubTitle)}
            </div>
            <div className="detailText">
              <div className="detailTitle">
                {DispText(leftDetail)}
              </div>
              <div className="annotationText">
                {DispText(leftAnnotationText)}
                {DispText(leftAsteriskText)}
              </div>
            </div>
          </div>
  
          <div className="PcCenterContent ContainerItemCenter">
            <img className="PcArrowImage" src={ThanksArrow} alt="arrow" />
          </div>
  
          <div className="PcRightContent ContainarItemRight">
            <div className="PcRightImagebox">
              <img className="PcRightImage" src={ThanksRight} alt="image2" />
            </div>
            <div className="SubTitle">
              {DispText(rightSubTitle)}
            </div>
            <div className="detailText">
              <div className="detailTitle">
                {DispText(rightDetail)}
              </div>
              <div className="annotationText">
                {DispText(rightAnnotationText)}
              </div>
            </div>
          </div>
        </div>
      </PcBasicTemplate>
    </div>
  );
};
  
  
export default PresentPC;